export const AdditionalNoticesSection = () => (
  <section>
    <h2>11. Additional Notices</h2>

    <p>
      Updates and Amendments: We may update and amend this Privacy Policy from
      time to time by posting an amended version on our Services. The amended
      version will be effective as of the date it is published. We will provide
      prior notice if we believe any substantial changes are involved via any of
      the communication means available to us or via the Sites, Platform and/or
      Services. After such notice period, all amendments shall be deemed
      accepted by you.
    </p>

    <p>
      External Links: While our Sites, Platform and/or Services may contain
      links to other websites or services, we are not responsible for their
      privacy practices. We encourage you to pay attention when you leave our
      Sites, Platform and/or Services for the website or application of such
      third parties, and to read the privacy policies of each and every website
      and service you visit. This Privacy Policy applies only to our Sites,
      Platform and/or Services.
    </p>

    <p>
      Our Services are not designed to attract children under the age of 16: We
      do not knowingly collect Personal Data from children and do not wish to do
      so. If we learn that a person under the age of 16 is using the Sites,
      Platform and/or Services, we will attempt to prohibit and block such use
      and will make our best efforts to promptly delete any Personal Data stored
      with us with regard to such child. If you believe that we might have any
      such data, please contact us by e-mail at{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>.
    </p>

    <p>
      Questions, concerns or complaints: If you have any comments or questions
      regarding our Privacy Policy, or if you have any concerns regarding your
      Personal Data held with us, please contact Volca's support at{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>. If you are a
      GDPR-protected individual, you also have the right to lodge a complaint
      with an EU supervisory authority.
    </p>
  </section>
);
